import React, { useState, useEffect } from 'react';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Grid from '@mui/material/Unstable_Grid2';
import Divider from '@mui/material/Divider';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';

import { shadows } from '@mui/system';
import SearchIcon from '@mui/icons-material/Search';


import moment from 'moment';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';



import { Link, useNavigate, useParams } from 'react-router-dom';

const SearchNavBar = ({ query, username, startdate, enddate, language }) => {

    const [modified, setModified] = useState(false);
    const [selectedRange, setSelectedRange] = useState(false);


    const [state, setState] = React.useState({
        lang: language,
        enteredQuery: query,
        enteredUsername: username,
        startDate: startdate,
        endDate: enddate,
        defRange: ""

    })


    function handleChange(evt) {
        if ([evt.target.name] == "defRange" && evt.target.value !== "0") {
            setSelectedRange(true)
        }
        else if ([evt.target.name] == "defRange") {
            setSelectedRange(false)
        }
        setModified(true)
        const value = evt.target.value;
        setState({
            ...state,
            [evt.target.name]: value
        });
    }



    function safeUserData() {

        if (document.getElementById("dateRange").value !== "0") {
            // setSelectedRange(true)
            // setDefRange(document.getElementById("dateRange").value)
        }
        else if (document.getElementById("dateRange").value === "0") {
            // setSelectedRange(false)
        }
    }

    const sendForm = async () => {
        setModified(false)
        let string = `/search?q=${state.enteredQuery}`
        console.log(state.enteredUsername)
        if (state.enteredUsername !== undefined && state.enteredUsername.length > 2) {
            string = string + `&u=${state.enteredUsername}`
        }
        if (selectedRange) {
            setSelectedRange(false)
            console.log(state.defRange)

            let today = new Date()
            let last = new Date(today.setMonth(today.getMonth() - state.defRange))
            today = new Date()
            today = moment(today).format('YYYY-MM-DD')
            last = moment(last).format('YYYY-MM-DD')
            string = string + `&s=${last}&e=${today}`
        }
        else {
            if (state.startDate !== undefined && state.startDate.length > 2) {
                string = string + `&s=${state.startDate}`
            }
            if (state.endDate !== undefined && state.endDate.length > 2) {
                string = string + `&e=${state.endDate}`
            }
        }
        if (state.lang !== undefined && state.lang.length > 1) {
            string = string + `&l=${state.lang}`
        }
        navigate(string);

    }

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            sendForm();
        }

    }


    //const [query, setQuery] = useState('');
    const navigate = useNavigate()
    const { page } = useParams();



    return (
        <Box sx={{
            boxShadow: 5,
            bgcolor: "#1e1e1e",
            p: 1,
            m: 1,
            borderRadius: 1,
            marginLeft: 0,
            marginRight: 0,
        }}>
            <Grid container 
                direction={{ xs: 'column', md: 'row' }}
                spacing={{ xs: 2, md: 2 }}id="searchForm stack"
            >
                <Grid xs={12} md={7}>
                {/* Query  */}
                <item> <TextField fullWidth id="outlined-basic query" label="Query" variant="standard" onChange={handleChange}
                    defaultValue={state.enteredQuery} name="enteredQuery" onKeyDown={handleKeyDown}/></item>

                {/* Username  */}
                <item><TextField fullWidth id="outlined-basic username" label="Username" name="enteredUsername" variant="standard" onChange={handleChange}
                    defaultValue={state.enteredUsername} onKeyDown={handleKeyDown} /></item>
                {/* Language  */}
                <item>
                    <FormControl fullWidth variant="standard">
                        <InputLabel fullWidth id="languageSelect">Language</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="language"
                            name="lang"
                            value={state.lang}
                            label="Language"
                            onChange={handleChange}
                        >
                            <MenuItem value="0" selected><em>None</em></MenuItem>
                            <MenuItem value="de">German</MenuItem>
                            <MenuItem value="en">English</MenuItem>
                        </Select>
                    </FormControl>
                </item>
                </Grid>

            

                {/* Date Range  */}
                <Grid xs={12} md={5} id="dateParams search">
                {selectedRange ?

                    <item> <TextField fullWidth id="date startdate" variant="standard" label="Start Date" type="date" onChange={handleChange} value={state.startDate} name="startDate" onKeyDown={handleKeyDown} InputLabelProps={{
                        shrink: true,
                    }} disabled /> </item>
                    :
                    <item>  <TextField fullWidth id="date startdate" variant="standard" label="Start Date" type="date" name="startDate" onChange={handleChange}
                        value={state.startDate} onKeyDown={handleKeyDown} InputLabelProps={{
                            shrink: true,
                        }} /> </item>
                }

                {selectedRange ?
                    <item><TextField fullWidth id="date endDate" label="End Date" type="date" variant="standard"
                        name="endDate" onChange={handleChange} defaultValue={state.endDate} onKeyDown={handleKeyDown} InputLabelProps={{
                            shrink: true
                        }} disabled /> </item>
                    :
                    <item><TextField fullWidth id="date endDate" label="End Date" type="date" variant="standard"
                        name="endDate" onChange={handleChange} defaultValue={state.endDate} onKeyDown={handleKeyDown} InputLabelProps={{
                            shrink: true,
                        }} /> </item>
                }


                
                {/* Predefined Ranges  */}
                <FormControl fullWidth variant="standard">

                    <item> <InputLabel id="languageSelect"> Date Ranges</InputLabel>
                        <Select fullWidth
                            id="defRange"
                            label="Predefined range"
                            name="defRange"
                            onChange={handleChange}
                        >
                            <MenuItem value="0" selected><em>None</em></MenuItem>
                            <MenuItem value="1">1 month</MenuItem>
                            <MenuItem value="3">3 months</MenuItem>
                            <MenuItem value="6">6 months</MenuItem>
                            <MenuItem value="12">1 year</MenuItem>
                            <MenuItem value="24">2 years</MenuItem>
                        </Select></item>
                </FormControl>

                </Grid>


                <Grid xs>
                {
                    (modified === false) ?

                        <Button fullWidth variant="contained" type="submit" id="searchForm submit" endIcon={<SearchIcon />} disabled>
                            Search
                        </Button>
                        :
                        <Button fullWidth variant="contained" type="submit" id="searchForm submit" endIcon={<SearchIcon />} onClick={sendForm} >
                            Search
                        </Button>
                }
                </Grid>
                  </Grid>

            




        </Box>
    );

}


export default SearchNavBar